import ReportsApiService from '@/api/client/services/ReportsApiService';
import getFieldNameForPrintAndSign from '@/helpers/getFieldNameForPrintAndSign';
import isEmptyId from '@/helpers/isEmptyId';

import PrintService, { Format, ICfg as ICfgBase } from './PrintService';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type EntityInstance = any;

export interface ICfg extends ICfgBase {
  cacheGuid?: string;
  ns: string;
  pointCode?: bigint;
}

/**
 *
 */
export default class ReportsPrintService extends PrintService {
  cacheGuid?: string;
  entityInstance: EntityInstance;
  ns: string;
  pointCode?: string | number | bigint;
  reportsApiService: ReportsApiService;
  epk: number;

  constructor(cfg: ICfg) {
    super(cfg);

    this.cacheGuid = cfg.cacheGuid;
    this.epk = cfg.epk;
    this.entityInstance = undefined;
    this.ns = cfg.ns;
    this.pointCode = cfg.pointCode;
    this.reportsApiService = new ReportsApiService();
  }

  fileNameNew(format: Format) {
    return `${this.pointCode ?? this.cacheGuid}.${format}`;
  }

  async init() {
    if (isEmptyId(this.cacheGuid) || !this.entityInstance) {
      const reportsApiService = this.reportsApiService;
      const r = await reportsApiService.docGet({
        ns: this.ns,
         
        pointCode: this.pointCode!,
      });

      if (!r.status) {
        this.isInited = true;
        return false;
      }
      const epkReport = r.response as EntityInstance;
      this.entityInstance = epkReport;
      this.cacheGuid = epkReport.req_cache_guid;
      this.epk = epkReport.dim_epk_code;
    }

    return super.init();
  }

  printCheckCancel() {
    if (this.cacheGuid) return false;

    this.errorShow('UNKNOWN', 'cacheGuid пуст');
    this.setIsLoading(false);
    return true;
  }

  async urlNew(
    format?: string,
    isLatest?: boolean | undefined,
    mode?: string
  ): Promise<string | undefined> {
    console.log('urlNew>', {
      format,
      isLatest,
      mode,
      entityInstance: this.entityInstance,
    });
    if (isLatest) {
      if (this.entityInstance) {
        const fieldName =
          (format && getFieldNameForPrintAndSign(format, mode)) || '';
        console.log('fieldName=', fieldName);

        if (format?.includes('+') && Array.isArray(fieldName)) {
          const formats = format.split('+');
          return fieldName.reduce((obj, fieldWithUrl, index) => {
            obj[formats[index]] = this.entityInstance[fieldWithUrl];
            return obj;
          }, {});
        }

        console.log(
          'this.entityInstance[fieldName]=',
          this.entityInstance[fieldName as string]
        );
        return this.entityInstance[fieldName as string];
      } else {
        this.errorShow('UNKNOWN', 'entityInstance пуст');
        return;
      }
    }

    let r = {
      status: false,
      errors: ['Передан некорректный режим печати: ' + mode],
    };
    if (mode === 'svod-one-year') {
      r = await this.reportsApiService.print(
         
        { ns: this.ns, uuid: this.cacheGuid! },
        { result_format: format }
      );
    } else if (mode === 'svod-five-years') {
      r = await this.reportsApiService.printFiveYears(
        { ns: this.ns, epk: this.epk },
        { result_format: format }
      );
    }
    if (!r.status) {
      return;
    }

    /* TODO: Fix. Maybe nested `.response` at dev only */
    while ('response' in r) {
      r = r.response;
    }

    return r.result_download_url;
  }
}
